import React from 'react';
import PropTypes from 'prop-types';
import { flattenHTMLToAppURL } from '@plone/volto/helpers/Url/Url';

const RichTextRender = ({ content }) => {
  const textToDisplay = content?.data?.replace(/(<([^>]+)>)/g, '') ?? '';
  const hasContent = textToDisplay.length > 0 ? true : false;

  return hasContent ? (
    <div
      dangerouslySetInnerHTML={{ __html: flattenHTMLToAppURL(content.data) }}
    />
  ) : null;
};
/**
 * RichText view component class.
 * @function RichText
 * @params {object} content: Content object.
 * @returns {string} Markup of the component.
 */
const RichText = ({ title, titleTag, content, children }) => {
  let content_to_display = RichTextRender({
    content: content,
  });

  const TitleTag = titleTag ?? 'h2';

  return content_to_display || children ? (
    <>
      {title && <TitleTag>{title}</TitleTag>}
      {content_to_display}
      {children}
    </>
  ) : null;
};
export default RichText;

RichText.propTypes = {
  title: PropTypes.string,
  content: PropTypes.object,
  add_class: PropTypes.string,
  titleTag: PropTypes.string,
};
